import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../api";
import { useAuth } from "../auth";
import { Footer } from "../App";

export default function Optin() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [mode, setMode] = useState("register"); // register | login
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loginError, setLoginError] = useState("");

  const submitRegister = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await api("/auth/magic-link", {
        method: "POST",
        body: JSON.stringify({ email, name }),
      });
      if (res.token) {
        setToken(res.token);
        setUser(res.user);
        navigate("/");
        return;
      }
      // Admin email → magic link path
      setSent(true);
    } catch (err) {
      setError(err.message || "Something went sideways. Try again?");
    } finally {
      setBusy(false);
    }
  };

  const submitLogin = async (e) => {
    e.preventDefault();
    setBusy(true);
    setLoginError("");
    try {
      const res = await api("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email: loginEmail }),
      });
      if (res.token) {
        setToken(res.token);
        setUser(res.user);
        navigate("/dashboard");
        return;
      }
      if (res.magic_link_sent) setSent(true);
    } catch (err) {
      const msg = err.message || "";
      if (msg.includes("not_registered")) {
        setLoginError("We don't know that email yet. Pop your name and email in above and take the quiz first.");
      } else if (msg.includes("no_results")) {
        setLoginError("That email hasn't finished a quiz yet. Register above and take the quiz to start your account.");
      } else {
        setLoginError(msg || "Something went sideways. Try again?");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="frame">
      <header className="top"><div className="brand"><b>Oracle BFF</b></div></header>
      <div className="auth-wrap">
        <div className="auth-card" data-testid="optin-card">
          <div className="eyebrow">Meet the deck that gets you</div>
          {!sent ? (
            <>
              <h1>First things first: tell me who's playing</h1>
              <p className="sub">
                Pop in your name and email and you'll jump straight into the quiz (no password needed). Your matches and favorites gets saved to your account so you can come back to review or take the quiz again at any time.
              </p>
              <form onSubmit={submitRegister} data-testid="optin-form">
                <div className="field">
                  <label className="field-label" htmlFor="optin-name">Your name</label>
                  <input id="optin-name" data-testid="optin-name-input" value={name}
                    onChange={(e) => setName(e.target.value)} placeholder="Jen" autoComplete="name" />
                </div>
                <div className="field">
                  <label className="field-label" htmlFor="optin-email">Email</label>
                  <input id="optin-email" data-testid="optin-email-input" type="email" required
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com" autoComplete="email" />
                </div>
                <button className="stamp-btn solid" data-testid="optin-submit-button" type="submit" disabled={busy}>
                  {busy ? "One sec…" : "Start the Quiz"}
                </button>
                {error && <p className="auth-error" data-testid="optin-error">{error}</p>}
              </form>

              <div className="auth-divider">or</div>

              {mode === "register" ? (
                <button className="retake" data-testid="show-login-button" type="button"
                  onClick={() => setMode("login")}>
                  Already took the quiz? Log in here
                </button>
              ) : (
                <form onSubmit={submitLogin} data-testid="login-form">
                  <div className="field">
                    <label className="field-label" htmlFor="login-email">
                      Already took the quiz? Log in with your email
                    </label>
                    <input id="login-email" data-testid="login-email-input" type="email" required
                      value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)}
                      placeholder="you@example.com" autoComplete="email" />
                  </div>
                  <button className="stamp-btn" data-testid="login-submit-button" type="submit" disabled={busy}>
                    {busy ? "One sec…" : "Log In"}
                  </button>
                  {loginError && <p className="auth-error" data-testid="login-error">{loginError}</p>}
                </form>
              )}
            </>
          ) : (
            <div className="auth-success" data-testid="optin-success-message">
              <p className="big">Check your inbox!</p>
              <p className="sub">
                I just sent a sign-in link to <strong>{email || loginEmail}</strong>. Click it to
                jump into your account. Your results and favorites are waiting.
              </p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
